export default __webpack_public_path__ + "static/exp1-648e3e96e85beefac80fbc5a802ef6d3.png";